// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import de from "./de.json";
// import LanguageDetector from "i18next-browser-languagedetector";

const savedLanguage = localStorage.getItem("language") || "de";

i18n
  //   .use(LanguageDetector) // auto-detects the browser language
  .use(initReactI18next)
  .init({
    fallbackLng: savedLanguage,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    resources: {
      en: {
        translation: en,
      },
      de: {
        translation: de,
      },
      // add more languages here
    },
  });

export default i18n;
